import React from 'react';
import {useTheme} from 'Theme/ThemeContext';
import Button from 'Core/components/elements/Button/Button';
import {FC, FR} from 'WideLayout/Layouts';
import {useNavigate} from 'react-router-dom';
import {IGuide} from "Types/psychology/guide";

interface GuideDetailProps {
    guide: IGuide;
    cls?: string;
}

const GuideDetail: React.FC<GuideDetailProps> = ({guide, cls}) => {
    const {plt} = useTheme();
    const navigate = useNavigate();

    const handleBuy = () => {
        navigate(`/order/guide/${guide.id}`, {state: {product: guide}});
    };

    return (
        <FC cls={`guide-detail ${cls}`} g={1} maxW={700}>
            <h2>{guide.name}</h2>
            <FR sx={{whiteSpace: 'pre-wrap'}} color={plt.text.primary50}>
                {guide.description}
            </FR>
            {!guide.accessed && !guide.is_public && (
                <Button
                    className={'mt-2'}
                    variant={'contained'}
                    color={'primary'}
                    onClick={handleBuy}>
                    Купить
                </Button>
            )}
            {guide.accessed && guide.files && guide.files.length > 0 && (
                <FR g={1} wrap>
                    {guide.files.map((fileObj, index) => (
                        <Button
                            key={index}
                            variant={'contained'}
                            color={'primary'}
                            onClick={() => window.open(fileObj.file, '_blank')}>
                            Скачать файл {index + 1}
                        </Button>
                    ))}
                </FR>
            )}
            {guide.accessed && (!guide.files || guide.files.length === 0) && (
                <FR>
                    Нет доступных файлов для скачивания.
                </FR>
            )}
        </FC>
    );
};

export default GuideDetail;
